export async function loadUnreadNotifications(client,userId){
 if(!userId)return [];
 const {data,error}=await client.from('notifications').select('*').eq('user_id',userId).eq('read',false).order('created_at',{ascending:false}).limit(50);
 if(error)throw Error('Could not load notifications.');
 return data||[];
}
export async function readOwnNotification(client,userId,id){
 if(!userId||!id)throw Error('Sign in to clear this notification.');
 const {data,error}=await client.from('notifications').update({read:true}).eq('user_id',userId).eq('id',id).select('id');
 if(error||!data?.length)throw Error('Could not clear this notification. Check your connection and retry.');
}
